import React, { useState } from "react";
import { StyleSheet } from "react-native";
import { IconButton, List, Menu } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { File } from "../types";
import { formatModifiedTime } from "../utils/formatTime";
import { getFileIcon } from "../utils/getFileIcon";

interface FileListItemProps {
  file: File;
  onOpen: (file: File) => void;
  onDownload: (file: File) => void;
  onShare: (file: File) => void;
  onRename: (file: File) => void;
  onDelete: (file: File) => void;
  onViewDetails: (file: File) => void;
}

export default function FileListItem({
  file,
  onOpen,
  onDownload,
  onShare,
  onRename,
  onDelete,
  onViewDetails,
}: FileListItemProps) {
  const [menuVisible, setMenuVisible] = useState(false);
  const { t } = useTranslation();

  const closeMenu = () => setMenuVisible(false);

  return (
    <List.Item
      title={file.name}
      titleNumberOfLines={1}
      description={`${formatModifiedTime(file)} - ${file.size}`}
      left={(props) => <List.Icon {...props} icon={getFileIcon(file.type)} />}
      right={(props) => (
        <Menu
          visible={menuVisible}
          onDismiss={closeMenu}
          anchor={
            <IconButton
              {...props}
              icon="dots-vertical"
              onPress={() => setMenuVisible(true)}
            />
          }
        >
          <Menu.Item
            onPress={() => {
              closeMenu();
              onDownload(file);
            }}
            title={t("Download")}
          />
          <Menu.Item
            onPress={() => {
              closeMenu();
              onShare(file);
            }}
            title={t("Share")}
          />
          <Menu.Item
            onPress={() => {
              closeMenu();
              onViewDetails(file);
            }}
            title={t("Properties")}
          />
          <Menu.Item
            onPress={() => {
              closeMenu();
              onRename(file);
            }}
            title={t("Rename")}
          />
          <Menu.Item
            onPress={() => {
              closeMenu();
              onDelete(file);
            }}
            title={t("Delete")}
          />
        </Menu>
      )}
      onPress={() => onOpen(file)}
      style={styles.item}
    />
  );
}

const styles = StyleSheet.create({
  item: {
    borderRadius: 12,
  },
});
